module.exports = {
  "id": "24f07900-e57a-430e-805a-e0daab7ad039",
  "gtmIds": [
    "GTM-NV2DFHG2",
    "GTM-KLS3LW5"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "Kaunertaler Gletscher & Fendels",
  "language": "de-DE",
  "defaultDateFormat": {
    "id": 1,
    "format": "DD/MM/YYYY",
    "name": "Numeric Day First (23/04/2026)"
  },
  "defaultNumberFormat": {
    "id": 3,
    "name": "European (Dot thousands, Comma decimals)",
    "format": "#.###,##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US",
    "de-DE"
  ],
  "website": "https://shop.kaunertaler-gletscher.at",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}